import { createFileRoute } from '@tanstack/react-router';

interface TagFailedSearchParams {
  reason?: string;
}

export const Route = createFileRoute('/tag/failed')({
  validateSearch: (search: Record<string, unknown>): TagFailedSearchParams => ({
    reason: typeof search.reason === 'string' ? search.reason : undefined,
  }),
});
